import React from "react";

const Button = ({ children, variant = "solid", size = "md", className = "", ...props }) => {
  const baseStyles = "inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-bookish-purple/30 disabled:opacity-50 disabled:pointer-events-none min-h-[44px]";

  const variants = {
    solid: "bg-bookish-royal text-white hover:bg-bookish-purpleAccent",
    outline: "border border-bookish-purple/15 text-bookish-purple hover:bg-bookish-purple/5",
    ghost: "text-bookish-purple hover:bg-bookish-purple/10",
    danger: "text-red-600 hover:bg-red-50 border border-red-200",
  };

  const sizes = {
    sm: "px-3 py-2 text-xs",
    md: "px-4 py-2.5 text-sm",
    lg: "px-6 py-3 text-base",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant] || ""} ${sizes[size] || sizes.md} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;